/** @jsx jsx */

import {
  IconButton,
  Select,
  SelectItem,
  Spacer,
  Tooltip,
} from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { ORDER_ITEMS, IssueOrderBy, IssueOrderDirection } from '../constants';

const Styles = {
  root: css`
    display: flex;
    align-items: flex-end;
  `,
  orderWrapper: css`
    display: flex;
    flex-direction: column;
    width: 130px;

    & > span {
      margin-bottom: 8px;
      font-weight: 600;
    }
  `,
};

type Props = {
  onChangeOrderBy: (orderBy: IssueOrderBy) => void;
  onChangeOrderDirection: (orderDireciton: IssueOrderDirection) => void;
  orderBy: IssueOrderBy;
  orderDirection: IssueOrderDirection;
};

function IssueOrder({
  onChangeOrderBy,
  onChangeOrderDirection,
  orderBy,
  orderDirection,
}: Props) {
  const isAscending = orderDirection === IssueOrderDirection.ASC;

  return (
    <div css={Styles.root}>
      <div css={Styles.orderWrapper}>
        <span>Sort by</span>
        <Select
          label="Issue ordered by"
          isLabelHidden
          selectedKey={orderBy}
          onChange={key => onChangeOrderBy(key as IssueOrderBy)}
          placeholder="Choose a order…"
        >
          {ORDER_ITEMS.map(item => (
            <SelectItem key={item.value} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </Select>
      </div>
      <Spacer width="10px" />
      <Tooltip
        content={isAscending ? 'Ascending' : 'Descending'}
        placement="bottom right"
      >
        <IconButton
          variant="primary"
          name={isAscending ? 'arrowSmallUp' : 'arrowSmallDown'}
          aria-label={isAscending ? 'Ascending' : 'Descending'}
          onPress={() =>
            onChangeOrderDirection(
              isAscending ? IssueOrderDirection.DESC : IssueOrderDirection.ASC
            )
          }
          size="small"
        />
      </Tooltip>
    </div>
  );
}

export default IssueOrder;
